"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_NAME = 'bSession';
exports.SESSION_DURATION = 30 * 60 * 1000; // 30 minutes
exports.FREE_SITE_DOMAINS = ['.wixsite.com', '.editorx.io'];
exports.WIX_DOMAIN = 'www.wix.com';
//# sourceMappingURL=config.js.map